import { render, staticRenderFns } from "./addconfig.vue?vue&type=template&id=5d621204&scoped=true&"
import script from "./addconfig.vue?vue&type=script&lang=js&"
export * from "./addconfig.vue?vue&type=script&lang=js&"
import style0 from "./addconfig.vue?vue&type=style&index=0&id=5d621204&scoped=true&lang=less&"
import style1 from "./addconfig.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d621204",
  null
  
)

export default component.exports